(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-512th-directory"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.hs512-picker[open]').forEach((picker) => {
    if (!picker.contains(event.target)) picker.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
  const picker = event.target.closest('.hs512-picker[open]');
  if (!picker) return;
  picker.open = false;
  picker.querySelector('summary').focus();
  event.preventDefault();
  event.stopPropagation();
});
document.addEventListener('focusin', (event) => {
  document.querySelectorAll('.hs512-picker[open]').forEach((picker) => {
    if (!picker.contains(event.target)) picker.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-ux-contact"]) return;
  try {
    
const hsMessage = document.querySelector('[data-hs-message]');
if (hsMessage) hsMessage.focus();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-ux-home"]) return;
  try {
    
if (!customElements.get('hs-unit-deck')) {
  customElements.define('hs-unit-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = Array.from(this.querySelectorAll('.hsux-unit-slide'));
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('.hsux-unit-controls').hidden = false;
      this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        this.paused = true;
        this.show(this.index + Number(button.dataset.step));
        this.sync();
      }, options));
      this.querySelector('[data-pause]').addEventListener('click', () => {
        this.paused = !this.paused;
        this.sync();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.sync();
      }, options);
      this.addEventListener('touchstart', event => {
        this.touchX = event.changedTouches[0].clientX;
        this.touchY = event.changedTouches[0].clientY;
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        const dx = event.changedTouches[0].clientX - this.touchX;
        const dy = event.changedTouches[0].clientY - this.touchY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          this.paused = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
          this.sync();
        }
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.paused = true;
        this.sync();
      }, options);
      this.sync();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-position]').textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    sync() {
      clearInterval(this.timer);
      const button = this.querySelector('[data-pause]');
      button.textContent = this.paused ? '\u25b6' : '\u275a\u275a';
      button.setAttribute('aria-label', this.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      if (!this.paused && !this.hovered && !this.focused && !document.hidden) {
        this.timer = setInterval(() => this.show(this.index + 1), 5000);
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-ux-page"]) return;
  try {
    
if (!customElements.get('hs-ux-groups')) {
  customElements.define('hs-ux-groups', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('[data-filter]');
      const wrapper = this.querySelector('[data-filter-wrapper]');
      const results = this.querySelector('[data-results]');
      const items = [...this.querySelectorAll('[data-group-name]')];
      if (!input || !wrapper || !results) return;
      wrapper.hidden = false;
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase();
        let shown = 0;
        items.forEach(item => {
          const match = item.dataset.groupName.toLocaleLowerCase().includes(query);
          item.hidden = !match;
          if (match) shown += 1;
        });
        results.textContent = shown ? `${shown} ${this.dataset.resultsLabel}` : this.dataset.emptyLabel;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
